"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionStoragePersistor = void 0;
var jwt_1 = require("../../internal/helpers/jwt");
var SessionStoragePersistor = /** @class */ (function () {
    function SessionStoragePersistor(keyPrefix, storage) {
        this.keyPrefix = keyPrefix;
        this.storage = storage || window.sessionStorage;
    }
    SessionStoragePersistor.prototype.set = function (tokens, keySuffix) {
        if (tokens) {
            this.storage.setItem(this.getFullKey(keySuffix), JSON.stringify(tokens));
        }
        else {
            this.storage.removeItem(this.getFullKey(keySuffix));
        }
    };
    SessionStoragePersistor.prototype.get = function (keySuffix) {
        var value = this.storage.getItem(this.getFullKey(keySuffix));
        if (!value) {
            return null;
        }
        try {
            var tokens = JSON.parse(value);
            var token = tokens.token, idToken = tokens.idToken, refreshToken = tokens.refreshToken;
            // Only set the tokens if they actually exist.
            // The auth client might only check to see if the property exists, not that it's actually falsy.
            var partialTokens = {};
            if (!(0, jwt_1.isTokenExpired)(token)) {
                partialTokens.token = token;
            }
            if (!(0, jwt_1.isTokenExpired)(idToken)) {
                partialTokens.idToken = idToken;
            }
            if (!(0, jwt_1.isTokenExpired)(refreshToken)) {
                partialTokens.refreshToken = refreshToken;
            }
            return partialTokens;
        }
        catch (e) {
            return null;
        }
    };
    SessionStoragePersistor.prototype.clear = function (keySuffix) {
        this.storage.removeItem(this.getFullKey(keySuffix));
    };
    SessionStoragePersistor.prototype.getFullKey = function (keySuffix) {
        return keySuffix ? "".concat(this.keyPrefix, "-").concat(keySuffix) : this.keyPrefix;
    };
    return SessionStoragePersistor;
}());
exports.SessionStoragePersistor = SessionStoragePersistor;
